import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { WHITE,BASE_URL } from '../../appConstants';
import axios from 'axios';
import appError from '../../appError';
import { useSelector } from 'react-redux';

type Tabs = {
  tab_name: string;
  tab_url: string;
};


const DashboardManagement:React.FC<{}> = () => {
  const [tabs, setTabs] = useState<Tabs[]>([
    { tab_name: "Overview", tab_url: "/Adsdashboard/overview/comparison" },
    { tab_name: "Sales Analysis" , tab_url: "/Adsdashboard/salesAnalysis"  },
    { tab_name: "Ads Analylsis" , tab_url: "/adsAnalysis"  },
    { tab_name: "Keyword Analysis" , tab_url: "/keywordAnalysis"  },
    { tab_name: "CST Analylsis" , tab_url: "/cstAnalysis"  },
    { tab_name: "Platform Analysis" , tab_url: "/platformAnalysis"  },
    { tab_name: "BSR Analysis" , tab_url: "/bsrAnalysis"  },
    { tab_name: "SFR Analysis" , tab_url: "/sfrAnalysis"  },
    { tab_name: "Graphical Analysis" , tab_url: "/graphicalAnalysis"  },
  ]);
  const [defaultTab, setDefaultTab] = useState<string>("Overview");
  const {brand_id} = useSelector((state: any) => state.appData);
  const navigate = useNavigate();

  const getBrandRange = async() => {
    const token = localStorage.getItem("token");
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getBrandRange?brand_id=${brand_id}`;
      const result = await axios.get(api, { headers });
      const {range} = result?.data?.data;
      localStorage.setItem("BrandRange",JSON.stringify(range));
    } catch (error) {
      appError(error);
    }
  }
  useEffect(()=> {
    if(brand_id){
    getBrandRange();
    }
  },[brand_id]);

  return (
    <div className="" style={{ height: "calc(100vh - 72px)", overflow: "scroll", scrollbarWidth: "none" }} >{/* margin top 40px, margin bottom 50px */}
      <div className="">
      <div
        className="flex px-10 items-center self-stretch"
        style={{
          backgroundColor: WHITE.W_100,
          boxShadow: `0px 4px 10px 4px rgba(99,99,99,0.05)`,
          zIndex:100,
        }}
      >
        {tabs?.length > 0 &&
          tabs.map((tab) => (
            <div
              className="flex p-4 justify-center items-center gap-2 w-full cursor-pointer"
              style={{borderBottom: defaultTab === tab?.tab_name ? `2px solid #1565C0` : ""}}
              onClick={()=> {
                setDefaultTab(tab?.tab_name);
                navigate(tab?.tab_url)
              }}
            >
              <div
                style={{
                  color: defaultTab === tab?.tab_name ? "#1565C0" : "#B7B7B9",
                  fontSize: "14px",
                  fontWeight: defaultTab === tab?.tab_name ? "700" : "500",
                  lineHeight: "18px",
                }}
              >
                {tab?.tab_name}
              </div>
            </div>
          ))}
      </div>
      <div className="">
        <Outlet/>
      </div>
    </div>
    </div>
  )
}

export default DashboardManagement
